import React from "react";
import { Link } from "react-router-dom";
import {
  ListItem,
  ListItemIcon,
  ListItemText,
  IconButton,
} from "@material-ui/core";
import { ExpandLess, ExpandMore } from "@material-ui/icons";
import PropTypes from "prop-types";
import { makeStyles, useTheme } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  listItem: {
    paddingTop: "8px",
    paddingBottom: "8px",
    minHeight: "40px",
    paddingRight: (props) => (props.isCollapsed ? "12px" : "16px"),
    paddingLeft: (props) => (props.isCollapsed ? "12px" : "16px"),
    margin: (props) => (props.isCollapsed ? "4px 8px" : "4px 12px"),
    justifyContent: (props) => (props.isCollapsed ? "center" : "flex-start"),
    position: "relative",
    width: (props) =>
        props.isCollapsed ? "" : "calc(100% - 24px)",
    // add hover effect
    "&:hover": {
      borderRadius: "8px",
      margin: (props) => (props.isCollapsed ? "4px 8px" : "4px 12px"),
      paddingLeft: (props) => (props.isCollapsed ? "12px" : "16px"),
      width: (props) =>
        props.isCollapsed ? "calc(100% - 16px)" : "calc(100% - 24px)",
      boxSizing: "border-box",
    },
  },

  listItemText: {
    marginLeft: "2px",
    color: theme.palette.primary.contrastText,
    display: (props) => (props.isCollapsed ? "none" : "block"),
    wordWrap: "break-word",
    whiteSpace: "nowrap",
    flex: 1,
  },
  activeListItem: {
    backgroundColor: "#0A2456 !important",
    borderRadius: "8px",
    margin: (props) => (props.isCollapsed ? "4px 8px" : "4px 12px"),
    width: (props) =>
      props.isCollapsed ? "calc(100% - 16px)" : "calc(100% - 24px)",
    boxSizing: "border-box",
  },
  activeItem: {
    color: theme.palette.secondary.main,
    paddingLeft: (props) => (props.isCollapsed ? "80%" : "0px"),
  },
  inactiveIcon: {
    color: theme.palette.primary.contrastText,
  },
  listItemIcon: {
    marginRight: "16px",
    minWidth: "auto",
    color: theme.palette.primary.contrastText,
    justifyContent: "center",
  },
  subItem: {
    paddingLeft: (props) => (props.isCollapsed ? "12px" : theme.spacing(4)),
  },
  // New styles for collapse icon
  collapseIcon: {
    color: theme.palette.primary.contrastText,
    padding: "4px",
    minWidth: "24px",
    width: "24px",
    height: "24px",
    display: (props) => (props.isCollapsed ? "none" : "flex"),
    alignItems: "center",
    justifyContent: "center",
    marginLeft: "auto",
    
  },
  collapseIconButton: {
    padding: "2px",
    color: "inherit",
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.1)",
    },
  },
  // Adjust list item when collapse icon is present
  listItemWithCollapse: {
    paddingRight: (props) => (props.isCollapsed ? "12px" : "8px"),
  },
}));

const SidebarItem = ({
  icon,
  text,
  to,
  active,
  onClick,
  isSubItem = false,
  disabled = false,
  isCollapsed = false,
  // New optional props for collapse functionality
  hasCollapseIcon = false,
  isExpanded = false,

}) => {
  const classes = useStyles({ isCollapsed });
  const theme = useTheme();

  const onItemClick = () => {

    if (onClick) {
      onClick();
    }
  };


  return (
    <ListItem
      disabled={disabled}
      button
      component={hasCollapseIcon ? "div" : Link}
      to={hasCollapseIcon ? undefined : to}
      selected={active}
      onClick={onItemClick}
      className={`${classes.listItem} ${isSubItem ? classes.subItem : ""} ${
        active ? classes.activeListItem : ""
      } ${hasCollapseIcon ? classes.listItemWithCollapse : ""}`}
    >
      <ListItemIcon
        className={`${classes.listItemIcon} ${active ? classes.activeItem : ""}`}
      >
        {typeof icon === "string" ? (
          <img src={icon} alt={text} width="24" height="24" />
        ) : (
          icon
        )}
      </ListItemIcon>

      <ListItemText
        primary={text}
        className={classes.listItemText}
        primaryTypographyProps={{
          style: {
            fontWeight: active ? theme.typography.fontWeightBold : "normal",
          },
        }}
      />

      {/* Optional collapse icon */}
      {hasCollapseIcon && !isCollapsed && (
        <div className={classes.collapseIcon}>
          <IconButton
            size="small"
            className={`${classes.collapseIconButton} collapse-icon-button`}
            aria-label={isExpanded ? "Collapse" : "Expand"}
          >
            {isExpanded ? (
              <ExpandLess fontSize="small" />
            ) : (
              <ExpandMore fontSize="small" />
            )}
          </IconButton>
        </div>
      )}
    </ListItem>
  );
};

SidebarItem.propTypes = {
  icon: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired,
  text: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
  active: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
  isSubItem: PropTypes.bool,
  disabled: PropTypes.bool,
  isCollapsed: PropTypes.bool,
  // New optional props
  hasCollapseIcon: PropTypes.bool,
  isExpanded: PropTypes.bool,
};

export default SidebarItem;
